import linkTypes from '../constants/link-types';
import fieldNames from '../constants/field-names';

const buildLinkConfigFromFieldsValues = (linkType, fieldsValues = {}) => {
  const linkConfig = {};

  if (!linkType) {
    return linkConfig;
  }

  switch (linkType) {
    case linkTypes.ANCHOR: {
      linkConfig.reference = fieldsValues[fieldNames.ANCHOR_REFERENCE];
      linkConfig.pageId = fieldsValues[fieldNames.ANCHOR_PAGE_ID];
      break;
    }

    case linkTypes.EXTERNAL: {
      linkConfig.url = fieldsValues[fieldNames.EXTERNAL_URL];
      linkConfig.targetBlank = fieldsValues[fieldNames.EXTERNAL_TARGET_BLANK_SWITCHER] ?? false;
      linkConfig.nofollow = fieldsValues[fieldNames.EXTERNAL_NOFOLLOW_SWITCHER] ?? false;
      break;
    }

    case linkTypes.PHONE: {
      linkConfig.reference = fieldsValues[fieldNames.PHONE_REFERENCE];
      break;
    }

    case linkTypes.MAIL: {
      linkConfig.reference = fieldsValues[fieldNames.MAIL_REFERENCE];
      break;
    }

    case linkTypes.PAGE: {
      linkConfig.reference = fieldsValues[fieldNames.PAGE_REFERENCE];
      break;
    }

    case linkTypes.DOWNLOAD: {
      linkConfig.download = fieldsValues[fieldNames.DOWNLOAD_FILE_NAME];
      linkConfig.file = fieldsValues[fieldNames.DOWNLOAD_FILE]?.[0];
      linkConfig.reference = fieldsValues[fieldNames.DOWNLOAD_REFERENCE];
      linkConfig.downloadOption = fieldsValues[fieldNames.DOWNLOAD_OPTION];
      linkConfig.customPath = fieldsValues[fieldNames.DOWNLOAD_CUSTOM_PATH];
      linkConfig.customPathEnabled = fieldsValues[fieldNames.DOWNLOAD_CUSTOM_PATH_SWITCHER];
      break;
    }

    case linkTypes.BINDING: {
      // The binding id is stored on the `data-cmsv` attribute, not in `ws-link-config`, so nothing to map here.
      break;
    }

    default:
      break;
  }

  return linkConfig;
};

export default buildLinkConfigFromFieldsValues;
